module.exports = __webpack_public_path__ + "img/redbg_front@3x.348e1402.png";